import React from 'react';
import { Paragraph } from 'common-components/typography';
import { Avatar } from 'antd';
import { PrimaryButton } from 'common-components/buttons';
import _ from 'lodash';
import { EditRecurringMode, ShiftSlotStatus } from 'utilities/enum-utils';
import WorkerStatusTag from 'common-components/tags/WorkerStatusTag';
import { Text } from '@good/ui/core';
import { Worker } from './types';

interface AssignWorkerStep4Props {
  selectedWorker: Worker | null;
  isShiftStatusPending: boolean;
  isRemovePendingShiftSlots: boolean;
  isRecurring: boolean | undefined;
  selectedOption: EditRecurringMode | null;
  onClose: () => void;
}

export const AssignWorkerStep4 = ({
  selectedWorker,
  isShiftStatusPending,
  isRemovePendingShiftSlots,
  isRecurring,
  selectedOption,
  onClose,
}: AssignWorkerStep4Props) => {
  return (
    <div style={{ minHeight: 317 }} className='flex-colum'>
      <div className='flex-column'>
        <Paragraph>
          {`You have successfully assigned ${`${selectedWorker?.firstName} ${selectedWorker?.lastName}`} to this shift${!isShiftStatusPending ? ' as confirmed' : ''}`}
          {isRemovePendingShiftSlots ? ' and removed them from any conflicting shifts' : ''}
          {isRecurring &&
            selectedOption === EditRecurringMode.CurrentAll &&
            ', and all following bookings in this recurring series where there were no workers assigned'}
          .
        </Paragraph>
        {isShiftStatusPending && (
          <Paragraph>
            {`${selectedWorker?.firstName} ${selectedWorker?.lastName}`} will have to confirm this shift, or have the
            shift confirmed on her behalf before the booking can be started.
          </Paragraph>
        )}
      </div>
      <div className='text-align-center pt-large pb-x-large'>
        <div className='mt-medium'>
          <Avatar icon='user' size={120} className='mb-small' shape='square' src={selectedWorker?.attachmentUrl} />
          <br />
          <b>
            <Text size='x-large'>{`${selectedWorker?.firstName} ${selectedWorker?.lastName}`}</Text>
          </b>
          <div className='mt-small'>
            <WorkerStatusTag
              shiftSlotStatus={!isShiftStatusPending ? ShiftSlotStatus.CONFIRMED : ShiftSlotStatus.PENDING}
              size='x-large'
            />
          </div>
        </div>
      </div>

      <div className='text-align-right'>
        <PrimaryButton size='large' shape='rounded' onClick={onClose}>
          Close
        </PrimaryButton>
      </div>
    </div>
  );
};
